import React from "react";
import {GrantFormTwoSpanish} from "./GrantFormTwoSpanish";

export const ContactSectionFormTwoSpanish = ({className = ''}) => {

  return (
    <div >
      <div className="form-container">
        <GrantFormTwoSpanish />
      </div>
    </div>

  )
}